import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Commonheader from "../CommonUtils/Commonheader";
import "../index.css";
import { IoHomeSharp, IoToggleOutline } from "react-icons/io5";
import { MdEditDocument } from "react-icons/md";
// import ChangePassword from "../ChangePassword";
import { MenuItem } from "./ParentSection";

export function MenuBar({ children }) {

  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  const [activeMenu, setActiveMenu] = useState(localStorage.getItem("ServiceName") || "home");

  const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];
  const isChanged = sessionStorage.getItem("is_changed");

  // const filtered = menuData.filter(
  //   (item) =>
  //     item.service_name?.toLowerCase() !== "home" &&
  //     // item.display_name?.toLowerCase() !== "home"
  //     item.service_name?.toLowerCase() !== "home"
  // );
  const filtered = menuData.filter(
    (item) =>
      item.service_name?.toLowerCase() !== "home"
  );
  // const sorted = [...filtered].sort((a, b) => a.order_by - b.order_by);
  const sorted = [...filtered].sort(
    (a, b) => (a.priority || 0) - (b.priority || 0)
  );
  const parents = sorted.filter((item) => item.parent_id === null);
  const kids = sorted.filter((item) => item.parent_id !== null);
  const getServiceNameFromPath = (pathValue) => {
    if (!pathValue || pathValue === "home") return "home";
    const normalized = decodeURIComponent(pathValue);
    const matched = sorted.find(
      (item) => String(item?.target || "") === normalized || String(item?.service_name || "") === normalized
    );
    return matched?.service_name || normalized;
  };

  const updateServiceName = (value) => {
    localStorage.setItem("ServiceName", value);
    window.dispatchEvent(new Event("ServiceNameChanged"));
  };

  const hasHierarchy = parents.length > 0 && kids.length > 0;

  // ── REMOVED: the old useEffect that called navigate("/home") on every mount.
  //    That was the root cause — it redirected away from the current page on
  //    every reload and every time the component re-mounted.
  //    Instead: if the user lands on bare "/" with no path, redirect to /home.
  useEffect(() => {
    const path = location.pathname.replace("/", "");
    if (!path) {
      navigate("/home", { replace: true });
    }
  }, []);

  // ── Keep activeMenu highlight in sync with URL (back/forward/reload) ──────
  useEffect(() => {
    const path = location.pathname.replace("/", "") || "home";
    const serviceName = getServiceNameFromPath(path);
    setActiveMenu((prev) => (prev === serviceName ? prev : serviceName));
    if (localStorage.getItem("ServiceName") !== serviceName) {
      updateServiceName(serviceName);
    }
  }, [location.pathname, sorted]);

  useEffect(() => {
    const onResize = () => setSidebarOpen(window.innerWidth > 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const [routeKey, setRouteKey] = useState(0);

  // ── Clicking the same menu item forces child component to remount ─────────
  const handleSelect = (targetPath) => {
    const finalPath = String(targetPath || "home").replace(/^\/+/, "");
    const finalServiceName = getServiceNameFromPath(finalPath);

    setActiveMenu((prev) => (prev === finalServiceName ? prev : finalServiceName));
    if (localStorage.getItem("ServiceName") !== finalServiceName) {
      updateServiceName(finalServiceName);
    }

    if (location.pathname === `/${finalPath}`) {
      // Already on this path — bump key to force remount of children
      setRouteKey((k) => k + 1);
    } else {
      navigate(`/${finalPath}`);
    }
  };

  const [modal, setModal] = useState(false);

  // useEffect(() => {
  //   if (isChanged !== true && isChanged !== "true") // NOSONAR
  //     setModal(true);
  // }, [isChanged]);

  if (!menuData.length) return null;

  // ── Build menu items ──────────────────────────────────────────────────────
  const menuItems = hasHierarchy
    ? parents.map((parent) => ({
      item: parent,
      kids: kids
        .filter((c) => c.parent_id === parent.service_id)
        .sort((a, b) => a.order_by - b.order_by),
    }))
    : sorted.map((item) => ({ item, kids: [] }));

  return (
    <>
      <Commonheader />

      {/* <Modal
        show={modal}
        onHide={() => setModal(false)}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        animation={false}
        className="chage-passmodal"
      >
        <Modal.Body>
          <ChangePassword closeModal={() => setModal(false)} />
        </Modal.Body>
      </Modal> */}

      <div className="dashboard-container vh-100">
        <div className="main-area">
          <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

            <Button
              className="toggle-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {/* {sidebarOpen ? ( */}
              {/* // <img src="../images/toggle1.svg" className="img-fluid toggle1" alt="toggle1" /> */}
              <IoToggleOutline size={25} />
              {/* ) : (
                // <img src="../images/toggle2.svg" className="img-fluid toggle2" alt="toggle2" />
                <IoToggleOutline size={25} />

              )} */}
            </Button>

            <ul className="sidebar-menu">

              {/* Home - always shown */}
              <li
                className={`single-menu home-menu ${activeMenu === "home" ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleSelect("home")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleSelect("home");
                  }
                }}
              >
                <IoHomeSharp />
                <span className="child-itemnew">Home</span>
              </li>

              {/* Dynamic menu items */}
              {menuItems?.map(({ item, kids }) => (
                <MenuItem
                  key={item.service_id}
                  item={item}
                  kids={kids}
                  activeMenu={activeMenu}
                  onSelect={handleSelect}
                  sidebarOpen={sidebarOpen}
                  defaultIcon={MdEditDocument}
                />
              ))}

            </ul>

            <div className="sidebar-footer">
              <p className="mb-0">
                Powered By{" "}
                <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
                  <img src="../images/dashboard-footer.png" alt="" className="img-fluid" />
                </a>
              </p>
            </div>

          </aside>

          <main className="content-box">
            <div className="inner-content" key={routeKey}>
              {children}
            </div>
          </main>

        </div>
      </div>
    </>
  );
}

export default MenuBar;